export default __webpack_public_path__ + "static/media/walletConnect.c78adc0f.svg";